module.exports = __webpack_public_path__ + "static/media/tutorial-step-4.9aaafbca.png";